import React, {useEffect, useState} from 'react'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import {SaveInventoryItem} from '../../inventory/utils'
import {ItemStatus} from './ItemStatus'

interface StatusTooltipProps {
    item: SaveInventoryItem
    onClick: (item: SaveInventoryItem) => void
}

export function StatusTooltip({
                           item,
                           onClick
                       }: StatusTooltipProps) {
    const [itemStatus, setItemStatus] = useState('')

    useEffect(() => {
        if (item && item.progress) {
            let status = item.progress === 'q-delete' || item.progress === 'deleting'
                ? '' : item.excluded
            setItemStatus(status)
        }
    }, [item])

    return itemStatus ? (
        <Tooltip
            title={
                <h1 style={{
                    color: 'text.primary',
                    fontSize: 15,
                    fontWeight: 'medium'
                }}>
                    {itemStatus.startsWith('not-found:') ? 'not-found' : itemStatus}
                </h1>
            }
        >
            <Box
                fontSize="small"
                sx={{
                    cursor: 'pointer',
                    color: 'red'
                }}
                onClick={() => onClick(item)}
            >
                {itemStatus.split(':')[0]}
            </Box>
        </Tooltip>
    ) : <ItemStatus progress={item.progress} />
}
